import { render } from "./TenantCreate.vue?vue&type=template&id=77c5e92c&scoped=true"
import script from "./TenantCreate.vue?vue&type=script&lang=js"
export * from "./TenantCreate.vue?vue&type=script&lang=js"

import "./TenantCreate.vue?vue&type=style&index=0&id=77c5e92c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77c5e92c"]])

export default __exports__